// extracted by mini-css-extract-plugin
export default {"reset_password_page":"reset-password_reset_password_page__D+9Lf","link_container":"reset-password_link_container__vG9I7","submit_container":"reset-password_submit_container__i24SL"};